<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 10 10"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M5.17.82a.521.521 0 0 0-.521.522v3.127H1.52a.521.521 0 0 0 0 1.042H4.65V8.64a.521.521 0 0 0 1.042 0V5.51H8.82a.521.521 0 0 0 0-1.042H5.69V1.342A.521.521 0 0 0 5.17.82z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="50"
          d="M5.17.82a.521.521 0 0 0-.521.522v3.127H1.52a.521.521 0 0 0 0 1.042H4.65V8.64a.521.521 0 0 0 1.042 0V5.51v0H8.82a.521.521 0 0 0 0-1.042H5.69v0-3.127A.521.521 0 0 0 5.17.82z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
